import React, { Component } from "react";
import PropTypes from "prop-types";
import { change as changeFieldValue, Field, getFormValues } from "redux-form";
import { SelectInput, TextInput } from "../../../../../common/form";
import compensationTypeOptions from "../../../enums/compensationTypeOptions";
import calculationTypeOptions from "../../../enums/calculationTypeOptions";
import { connect } from "react-redux";
import { makeOptions } from "../associatedBrokers";
import classNames from "classnames";

const valueToUpdate = [
  "cashAdvance",
  "brokerPart",
  "brokerId",
  "clientBrokerRelationshipId",
  "compensationType",
  "calculationType",
];
class AssociatedBroker extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      cashAdvanceEnabled:
        this.props.brokerRelationship.compensationType === "YEARLY",
      calculationType: this.props.brokerRelationship.calculationType,
    };
  }

  componentDidMount() {
    const brokerRelationshipEntries = Object.entries(
      this.props.brokerRelationship
    );

    if (brokerRelationshipEntries.length) {
      Object.entries(this.props.brokerRelationship).forEach(([key, value]) => {
        if (valueToUpdate.includes(key))
          this.props.setFormValue(this.mangle(key), value);
      });
    } else {
      valueToUpdate.forEach((key) =>
        this.props.setFormValue(this.mangle(key), null)
      );
    }
  }

  componentDidUpdate(prevProps) {
    const currentRelationship = prevProps.brokerRelationship;
    const brokerRelationships = this.props.brokerRelationship;
    const formValuesBroker = this.props.formValues.broker;
    if (brokerRelationships && currentRelationship != brokerRelationships) {
      if (
        valueToUpdate.some(
          (val) =>
            brokerRelationships[val] !==
            formValuesBroker[this.props.rowIndex][val]
        )
      ) {
        Object.entries(brokerRelationships).forEach(([key, value]) => {
          if (valueToUpdate.includes(key)) {
            this.props.setFormValue(this.mangle(key), value);
          }
        });
      }
    }
  }

  removeRow = () => (event) => {
    event.preventDefault();
    const { brokerRelationship } = this.props;

    brokerRelationship.isArchived = true;
    this.props.setFormValue(this.mangle("isArchived"), true);
  };

  makeBrokerOptions = () => {
    const { rowIndex, brokers, formValues } = this.props;
    const currentBrokers = formValues.broker;
    let filteredBrokers = brokers;

    if (currentBrokers && brokers) {
      const selectedBrokersIds = currentBrokers.map(
        (broker) => broker.brokerId
      );
      filteredBrokers = brokers.filter((broker) => {
        return (
          !selectedBrokersIds.includes(broker.brokerId) ||
          (currentBrokers[rowIndex] &&
            broker.brokerId == currentBrokers[rowIndex].brokerId)
        );
      });
    }

    return makeOptions(filteredBrokers);
  };

  mangle = (str) => `broker[${this.props.rowIndex}].${str}`;

  handleCompensationTypeChanged = (_, value) =>
    value === "YEARLY" ? this.enableCashAdvance() : this.disableCashAdvance();

  handleCalculationTypeChanged = (_, value) => {
    this.setState({ calculationType: value });
    this.props.setFormValue(this.mangle("calculationType"), null);
  };

  enableCashAdvance = () => {
    this.setState({ cashAdvanceEnabled: true });
    this.props.setFormValue(this.mangle("cashAdvance"), 90);
  };

  disableCashAdvance = () => {
    this.setState({ cashAdvanceEnabled: false });
    this.props.setFormValue(this.mangle("cashAdvance"), null);
  };

  makeBrokerPartClass = () =>
    classNames({
      "percent-stepper": this.isPercentageBased(),
      dollar: this.state.calculationType === "FIXED",
    });

  isPercentageBased = () => this.state.calculationType === "PERCENTAGE";

  render = () => {
    const {
      brokerRelationship: {
        compensationType,
        calculationType,
        cashAdvance,
        brokerPart,
      },
      disabled,
    } = this.props;

    const mangle = this.mangle;

    const brokerPartProps = {
      type: "absNumber",
      ...(this.isPercentageBased() && {
        type: "stepper",
        min: "0",
        max: "100",
      }),
    };

    return (
      <tr className="associated-broker-row">
        <td className="broker-id-col">
          <Field
            id={mangle("brokerId")}
            name={mangle("brokerId")}
            component={SelectInput}
            options={this.makeBrokerOptions()}
            disabled={disabled}
          />
        </td>
        <td>
          <Field
            id={mangle("compensationType")}
            name={mangle("compensationType")}
            component={SelectInput}
            options={compensationTypeOptions}
            value={compensationType}
            disabled={disabled}
            onChange={this.handleCompensationTypeChanged}
          />
        </td>
        <td>
          <Field
            id={mangle("calculationType")}
            name={mangle("calculationType")}
            component={SelectInput}
            options={calculationTypeOptions}
            value={calculationType}
            disabled={disabled}
            onChange={this.handleCalculationTypeChanged}
          />
        </td>
        <td className="broker-part-col">
          <div className={this.makeBrokerPartClass()}>
            <Field
              id={mangle("brokerPart")}
              name={mangle("brokerPart")}
              {...brokerPartProps}
              component={TextInput}
              disabled={disabled}
              value={brokerPart}
            />
          </div>
        </td>
        <td className="broker-cash-advance-col">
          <div className="percent-stepper">
            <Field
              id={mangle("cashAdvance")}
              name={mangle("cashAdvance")}
              component={TextInput}
              type="stepper"
              min="0"
              max="100"
              value={cashAdvance}
              disabled={!this.state.cashAdvanceEnabled || disabled}
            />
          </div>
        </td>
        <td>
          {!disabled && (
            <span
              className="icon-bin archive-button action-icon"
              onClick={this.removeRow()}
            />
          )}
        </td>
      </tr>
    );
  };
}

AssociatedBroker.propTypes = {
  brokerRelationship: PropTypes.shape({
    brokerId: PropTypes.any,
    compensationType: PropTypes.any,
    calculationType: PropTypes.any,
    cashAdvance: PropTypes.any,
    brokerPart: PropTypes.any,
    isArchived: PropTypes.any
  }),
  rowIndex: PropTypes.number,
  deleteMe: PropTypes.func,
  disabled: PropTypes.bool,
  brokers: PropTypes.array,
  clearFormValue: PropTypes.func,
  setFormValue: PropTypes.func,
  formValues: PropTypes.object,
};

const mapStateToProps = (state) => ({
  formValues: getFormValues("client")(state),
});

const mapDispatchToProps = {
  setFormValue: (valueName, value) =>
    changeFieldValue("client", valueName, value),
};
export default connect(mapStateToProps, mapDispatchToProps)(AssociatedBroker);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/brokers/AssociatedBroker.js